<template>
  <div class="business-service">
    <div v-if="!showRecordPage">
      <div class="module-item-style">
        <div class="module-item-title">版本信息</div>
        <ul class="version-info-container">
          <li class="version-info-item">
            <div class="version-label">版本名称：</div>
            <div class="version-value">{{versionInfo.version_name}}</div>
          </li>
          <li class="version-info-item">
            <div class="version-label">座席数：</div>
            <div class="version-value"><span class="clientNUm">{{versionInfo.client_num}}</span> 个</div>
          </li>
          <li class="version-info-item" v-if="false">
            <div class="version-label">座席单价：</div>
            <div
                    class="version-value clientPrice"><span v-if="Number(versionInfo.client_price)">¥</span><span>
              {{versionInfo.client_price}}</span></div>
          </li>
          <li class="version-info-item">
            <div class="version-label">子账号数：</div>
            <div class="version-value">{{versionInfo.service_num}}</div>
          </li>
          <li class="version-info-item">
            <div class="version-label">截止时间：</div>
            <div class="version-value">{{versionInfo.deadline_time}}</div>
          </li>
        </ul>
      </div>

      <div class="module-item-style" v-if="isShow">
        <div class="module-item-title">付费版方案</div>

        <ul class="version-package-container">
          <li class="version-package-item"
              v-for="(item, i) in package"
              @click="chooseVersionHandler(item,i)">
            <div class="item-detail" :class="seletedIndex == i ? 'package-item-actived' : ''">
              <div class="package-name">
                <span>{{item.tcName}}</span>
              </div>
              <div class="package-detail-container">
                <div class="package-price">¥<span>{{item.totalPrice}}</span></div>
                <div class="package-num">{{item.clientNum}}座席每年</div>
              </div>
              <i v-if="seletedIndex == i ? true : false " class="selected-tc"></i>
            </div>
            <div class="package-tips" v-if="(seletedIndex == i && can == 1) ? true : false ">(当前版本)</div>
            <div class="package-tips" v-else>(购买该版本请联系客服经理)</div>
          </li>
        </ul>

        <div>
          <a class="know-defference" href="https://www.weiliaokefu.com/Scheme-index" target="_blank">了解版本详细区别</a>
        </div>
        <div class="version-renew-container" v-if="false">
          <div>
            <div class="module-item-title">选择续费时长</div>
            <el-select v-model="chooseYear" placeholder="请选择" class="renew-time">
              <el-option
                  v-for="item in years"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            <div class="module-item-title">座席数：{{chooseVersion.clientNum}}座席</div>
            <div class="renew-price">
              总价格：¥{{chooseVersion.totalPrice}}（{{chooseVersion.clientNum}}座席每年）* {{chooseYear}}年 = <span>¥{{getPrice(chooseVersion.totalPrice,chooseYear)}}</span>
            </div>
          </div>
          <div class="wl-btn" @click="goPay(chooseVersion,chooseYear)">立即支付</div>
        </div>

        <div class="version-detail-contact-us" v-if="contactShow">
          <div class="module-item-title">续费或升级请联系</div>
          <ul class="contact-container">
            <li class="contact-item">
              <div class="contact-label">
                <svg-icon icon-class="mobile"></svg-icon>
                手机：
              </div>
              <div class="contact-value">15394297736</div>
            </li>
            <li class="contact-item">
              <div class="contact-label">
                <svg-icon icon-class="QQ"></svg-icon>
                QQ：
              </div>
              <div class="contact-value">80068849</div>
            </li>
            <li class="contact-item wxCode">
              <el-tooltip placement="top">
                <div slot="content">
                  <img src="@/assets/images/wxQRCode.png" width="80" height="80" alt="">
                </div>
                <div class="contact-item">
                  <div class="contact-label">
                    <svg-icon icon-class="wechat"></svg-icon>
                    微信：
                  </div>
                  <div class="contact-value">15394297736</div>
                </div>
              </el-tooltip>

            </li>
            <li class="contact-item" v-if="false">
              <div class="contact-label">
                <svg-icon icon-class="service"></svg-icon>
                咨询热线：
              </div>
              <div class="contact-value">0571-56617245</div>
            </li>
          </ul>
        </div>
      </div>

      <!--<div class="module-item-style">
        <div class="module-item-title">升级信息(版本续费)</div>
        <el-table
            class="upgrade-info"
            stripe
            :header-cell-style="{background:'#f2f2f2'}"
            :data="tableData"
            style="width: 100%">
          <el-table-column
              prop="versionName"
              label="版本名称"
              width="180">
          </el-table-column>
          <el-table-column
              label="座席数/单价"
              width="180">
            <template slot-scope="scope">
              {{scope.row.clientNum}}个/¥{{scope.row.clientPrice}}
            </template>
          </el-table-column>
          <el-table-column
              prop="subAccountNum"
              label="子账号数">
          </el-table-column>
          <el-table-column
              prop="address"
              label="时长">
            <template slot-scope="scope">
              {{scope.row.time}}年
            </template>
          </el-table-column>
          <el-table-column
              prop="applyTime"
              label="申请时间">
          </el-table-column>
          <el-table-column
              prop="payPrice"
              label="支付价格">
          </el-table-column>
          <el-table-column
              width="180"
              label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 1">
                <span style="color: red;">已付款，等待审核</span>
              </div>
              <div v-else>
                <span class="wl-btn"
                      @click="versionToPay(scope.$index, scope.row)">付款</span>
                <span
                    class="wl-btn-cancel"
                    style="margin-left: 10px;border-color:#999999;color: #999999; background: none;"
                    @click="versionToDel(scope.$index, scope.row)">删除</span>
              </div>

            </template>
          </el-table-column>
        </el-table>
        
      </div>-->
      <business-operate-record class="mgt15"></business-operate-record>
    </div>
    <transition name="fade-transform" mode="out-in">
      <router-view v-if="showRecordPage"/>
    </transition>
  </div>
</template>

<script>
  import tableMulti from '@/components/table/table-multi'
  import businessOperateRecord from './business-operate-record'

  export default {
    name: 'business-service',
    data() {
      return {
        chooseYear: '1',
        needPay: '',
        versionInfo: {}, // 现有版本信息
        package: [], // 套餐
        seletedIndex: -1, // 当前的版本
        isShow: 1, // 是否显示-续费或升级请联系
        can: '0', //是否显示可以在线购买
        show: 'all', // 是否显示所有套餐，all所有，single 单个
        chooseVersion: {},
        years: [
          {label: '1年', value: '1'},
          {label: '2年', value: '2'},
          {label: '3年', value: '3'},
          {label: '4年', value: '4'},
          {label: '5年', value: '5'},
          {label: '6年', value: '6'},
        ],
        showRecordPage: false,
        tableData: [],
		contactShow:true, // 目前只隐藏公司id为51573、51930的
      }
    },
    components: {
      tableMulti,
      businessOperateRecord
    },
    watch: {
      '$route'(to, from) {
        if (to.name == 'businessServiceRecord') {
          this.showRecordPage = true
        } else {
          this.showRecordPage = false
        }
      }
    },
    created() {
      this.getDetail()
	  this.getUserInfo()
	  this.getSellerInfoStatus()
      let currentRoute = this.$route.name
      if (currentRoute == 'businessServiceRecord') {
        this.showRecordPage = true
      } else {
        this.showRecordPage = false
      }
    },
    methods: {
      /**
       * 表单操作
       * @param val
       */
      handleOperate(val) {

        let delData = []
        if (val.methods == "delMethods") {
          delData.push(val.row.id)
        } else if (val.methods == 'delAll') {
          if (val.row.length == 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的二维码名片',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          val.row.map((item) => {
            delData.push(item.id)
          })
        }
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
      },
      chooseVersionHandler(item, index) {
        if (this.can != 1) {
          // this.$message({
          //   message: '请联系客服经理！',
          //   type: 'warning',
          // })
          return false
        }
        this.chooseVersion = item
        this.seletedIndex = index
      },
      getPrice(price, year) {
        return price * year
      },
      getDetail() {
        this.$http.getServiceDetailAPI().then(res => {
          if (res.status == 1) {
            let info = res.data
            this.versionInfo = info.companyInfo
            this.package = info.package
            // this.isShow = info.isShow
            this.can = info.can
            this.show = info.show
            this.tableData = info.upgradeInfos
            this.package.map((item, i) => {
              if (item.versionId == info.version) {
                this.seletedIndex = i
                this.chooseVersion = item
              }
            })
          }
        })
      },
      goPay(versionInfo, time) {
        this.$http.versionCheckOrderAPI().then(res => {
          if(res.status == '1'){
            if(res.data == '1'){
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }else if(res.data == '0'){
              let payData = {
                type: '2',
                versionId: versionInfo.versionId,
                tcId: versionInfo.tcId,
                upgradeClientNum: 3,
                time: time
              }
              this.$http.versionPayAPI(payData).then(res => {
                this.$confirm('即将跳转支付, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  let div = document.createElement('div');
                  div.innerHTML = res; // html code
                  document.body.appendChild(div);
                  document.forms['punchout_form'].submit();
                }).catch(() => {

                });
              })
            }
          }
        })

      },
      versionToPay(index, row) {
        this.$confirm('即将跳转支付, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.versionWillPayAPI({
            id: row.id
          }).then(res => {
            if(res){
              if(res.length > 1000){
                let div = document.createElement('div');
                div.innerHTML = res; // html code
                document.body.appendChild(div);
                if(document.forms['punchout_form']){
                  document.forms['punchout_form'].submit();
                }
              }else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              }

            }else {
              this.$message({
                message: '出错了',
                type: 'error',
              })
            }


          }).catch( err => {

            console.log(err)
          })
        }).catch(() => {

        });

      },
      versionToDel(index, row) {
        this.$confirm('正在进行删除操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.delUpgradeInfoAPI({
            id: row.id
          }).then(res => {
            if (res.status == 1) {
              this.$message({
                message: res.msg,
                type: 'success',
              })
              this.getDetail()
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
        })

      },
	  getUserInfo() {
		 this.$http.userInfoAPI({}).then(res => {
			 if(res.status == 1){
				 const companyId = res.data.userInfo.companyId
				 if(companyId == 51573 || companyId == 51930 || companyId == 51924 || companyId == 52333 ){
					 this.contactShow = false
				 }
			 }
		 })
	  },
	  getSellerInfoStatus() {
		  this.$http.sellerInfoStatusAPI().then(res => {
			  console.log(res,'status')
			  if (res.status == 1) {
				  this.isShow = res.data.is_show
			  }
		  })
	  }
    }
  }
</script>

<style lang="scss">
  .business-service {

    .version-renew-container {
      padding-top: 20px;

      .renew-time {
        padding: 20px 0;
      }

      .renew-price {
        padding: 20px 0;
        color: #333;

        span {
          color: #FE8601;
        }
      }
    }

    .version-info-container {
      padding-top: 20px;

      .version-info-item {
        line-height: 40px;
        display: flex;

        .version-label {
          color: #999;
          width: 80px;
          text-align: right;
          padding-right: 10px;
        }

        .version-value {
          color: #333;

          .clientNUm {
            color: $mainColor;
            font-weight: bold;
            font-size: 18px;
          }

          &.clientPrice {
            color: $mainColor;

            span {
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
    }

    .version-package-container {
      display: flex;
      flex-wrap: wrap;
      padding: 30px 0;

      .version-package-item {

        margin-bottom: 20px;

        .package-tips {
          text-align: center;
          color: #999;
          padding-top: 9px;
          font-size: 12px;
        }

        .item-detail {
          display: flex;
          margin-right: 20px;
          align-items: center;
          border: 1px solid #fe8601;
          border-radius: $mainBorderRadius;
          height: 70px;
          cursor: pointer;
          position: relative;

          .selected-tc {
            display: inline-block;
            width: 72px;
            height: 72px;
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 99;
            background: url("~@/assets/images/selected.png") 100% 100% no-repeat;
          }

          .package-name {
            display: flex;
            width: 99px;
            height: 100%;
            align-items: center;
            justify-content: center;
            /*background-color: #409eff;*/
            background-color: #fe8601;
            color: #fff;
          }

          .package-detail-container {
            padding: 0 40px;
            text-align: center;
            width: 160px;

            .package-price {
              color: #333;

              span {
                font-size: 18px;
              }
            }

            .package-num {
              font-size: 12px;
              padding-top: 7px;
              color: #666;
            }
          }

          &.package-item-actived {
            border: 1px solid #fe8601;

            .package-name {
              background-color: #fe8601;
            }

            .package-price, .package-num {
              color: #fe8601;
            }
          }
        }
      }
    }

    .know-defference {
      color: $mainColor;
    }

    .version-detail-contact-us {
      margin-top: 37px;

      .contact-container {
        display: flex;
        flex-wrap: wrap;
        padding: 20px 0 0 0;

        .contact-item {
          display: flex;
          line-height: 40px;
          margin-right: 37px;
          color: #666;

          &.wxCode {
            cursor: pointer;
          }
        }
      }
    }

    .upgrade-info {
      margin-top: 20px;
      border: 1px solid #EBEEF5;
      border-bottom: 0;
    }
  }
</style>
